import React from "react"
import { Pagination } from "antd"
import styled from "styled-components"
import { t } from "i18next"
import { theme } from "../../../theme"
import { DASHBOARD_TYPE } from "../../../utils"
interface iPagination {
  className?: string
  current?: number
  hideOnSinglePage?: boolean
  total?: number
  showSizeChanger?: boolean
  pageSize?: number
  onChange?: (page: number, pageSize: number) => void
  onShowSizeChange?: (current: number, size: number) => void
  type?: string
}
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
`
const StyledPagination = styled(Pagination)<iPagination>`
  .ant-pagination-item {
    a {
      color: ${({ type, total }) =>
        type == DASHBOARD_TYPE.BUSINESS && !total
          ? theme.background.darkOrange
          : theme.font.colorSecondary2};
      :hover {
        color: ${({ type }) =>
          type == DASHBOARD_TYPE.BUSINESS && theme.background.orange};
      }
    }
    border: 1px solid ${theme.border.colorSecondary6};
    border-radius: 4px;
    :hover {
      border-color: ${({ type }) =>
        type == DASHBOARD_TYPE.BUSINESS
          ? theme.background.lightOrange
          : theme.border.colorSecondary5};
    }
  }
  & .ant-pagination-item-active {
    & a,
    a:hover {
      color: ${({ type }) =>
        type == DASHBOARD_TYPE.BUSINESS
          ? theme.background.darkOrange
          : theme.border.colorSecondary5};
    }
    border-color: ${({ type }) =>
      type == DASHBOARD_TYPE.BUSINESS
        ? theme.background.orange
        : theme.border.colorSecondary5} !important;
  }
  .ant-pagination-next,
  .ant-pagination-prev {
    :hover {
      button {
        color: ${({ type }) =>
          type == DASHBOARD_TYPE.BUSINESS
            ? theme.background.orange
            : theme.border.colorSecondary5};
        border: 1px solid
          ${({ type }) =>
            type == DASHBOARD_TYPE.BUSINESS
              ? theme.background.lightOrange
              : theme.border.colorSecondary5};
      }
    }
    button:disabled {
      border: 1px solid ${theme.border.colorSecondary6} !important;
      border-radius: 4px;
      color: ${theme.font.colorSecondary3} !important;
    }
  }
`

export const StyledPaginationComponent: React.FC<iPagination> = ({
  current,
  hideOnSinglePage = true,
  showSizeChanger = false,
  pageSize = 10,
  onChange,
  onShowSizeChange,
  total,
  className,
  type,
}) => {
  return (
    <Wrapper className={className}>
      <StyledPagination
        type={type}
        current={current}
        hideOnSinglePage={hideOnSinglePage}
        total={total}
        showSizeChanger={showSizeChanger}
        pageSize={pageSize}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showTotal={(total, range) =>
          `${t("paginationKey", {
            range: `${range[0]}-${range[1]}`,
            total: `${total}`,
          })}`
        }
      />
    </Wrapper>
  )
}
